<div class="tile-wrapper flex-1 d-flex fd-col ai-stretch">
  <ng-container [ngSwitch]="viewTile.tileType">

    <ng-container *ngSwitchCase="'major-properties'">
      <suvo-bi-major-properties-view-tile class="flex-1" [viewTile]="viewTile" [definition]="definition" [item]="item" [form]="form"
        [editItemMode]="editItemMode">
      </suvo-bi-major-properties-view-tile>
    </ng-container>

    <ng-container *ngSwitchCase="'paragraph'">
      <suvo-bi-paragraph-view-tile class="flex-1" [viewTile]="viewTile" [definition]="definition" [item]="item" [form]="form"
        [editItemMode]="editItemMode">
      </suvo-bi-paragraph-view-tile>
    </ng-container>


    <ng-container *ngSwitchCase="'rail-map'">
      <suvo-bi-rail-map-view-tile class="flex-1" [viewTile]="viewTile" [definition]="definition" [item]="item" [form]="form"
        [editItemMode]="editItemMode">
      </suvo-bi-rail-map-view-tile>
    </ng-container>

    <ng-container *ngSwitchCase="'properties'">
      <suvo-bi-properties-view-tile class="flex-1" [viewTile]="viewTile" [definition]="definition" [item]="item" [form]="form"
        [editItemMode]="editItemMode">
      </suvo-bi-properties-view-tile>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <span>Default.</span>
    </ng-container>

  </ng-container>
</div>